import type { Locale } from '../i18n-config';
import enDict from './dictionaries/en.json';
import deDict from './dictionaries/de.json';
import esDict from './dictionaries/es.json';
import frDict from './dictionaries/fr.json';
import itDict from './dictionaries/it.json';
import nlDict from './dictionaries/nl.json';
import plDict from './dictionaries/pl.json';

// We enumerate all dictionaries here for better linting and typescript support
const dictionaries = {
  en: enDict,
  de: deDict,
  es: esDict,
  fr: frDict,
  it: itDict,
  nl: nlDict,
  pl: plDict,
};

export const getDictionary = (locale: Locale) =>
  dictionaries[locale] ?? dictionaries.en;
